import React, { useState }  from 'react';
import  { useNavigate, Navigate } from 'react-router-dom'
import './App.css';
import { baseUrl } from '../shared';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

//NEED TO REBUILD MUCH MUCH BETTER....

export function ResetPassword() {


const [passwordOld, setPasswordOld] = useState ("");
const [passwordNew, setPasswordNew] = useState ("");
const [message, setMessage] = useState ("");
const [title, setTitle] = useState ("");
const [open, setOpen] = useState(false);
const navigate = useNavigate();

const sendUpdateUserPassword = async () => {   
    const url = baseUrl+"user/passwordreset";
    var payload = {
      "oldPassword": passwordOld,
      "newPassword": passwordNew,
    }
    await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        },
        body: ( "json", JSON.stringify( payload ) )
      })
      .then((response) => response.json())
        .then((data) => {
          console.log(data)
          if( data.status === 200) {
          setMessage(data.message);
          setTitle("Success");
          setOpen(true);
          } else if (data.status === 401) {
            setMessage(data.message);
            setTitle("Error");
            setOpen(true);
          }
        })
        .catch((err) => {
          setMessage(err.message);
          setTitle("Error");
          setOpen(true);
        });
};

  const handleClose = () => {
    if(!open) {
      setOpen(true);
    } else {
      setOpen(false);
      <Navigate to={'/'} />
      {navigate(0)}
    }
    };

  return (
    <Box sx={{ pt: 1 }}>
      <React.Fragment>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {title}
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
          {message}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

    <Box component="form">
         <TextField
        fullWidth
          margin="dense"
          id="oldPassword"
          name="oldPassword"
          required
          label="Current Password"
          variant="outlined"
          type="password"
          onChange={(e) => {
            setPasswordOld(e.target.value);
          }}
        />
         <TextField
        fullWidth
          margin="dense"
          id="newPassword"
          name="newPassword"
          required
          label="New Password"
          variant="outlined"
          type="password"
          onChange={(e) => {
            setPasswordNew(e.target.value);
          }}
        />
        <Button
          fullWidth
          variant="contained"
          disabled={!passwordNew || !passwordOld}
          onClick={sendUpdateUserPassword}
          sx={{ mt: 2 }}
        >
          Reset Password
        </Button>
    </Box>
    </Box>
  )
}
export default ResetPassword;